module.exports = __webpack_public_path__ + "static/media/Arrow.372c4a45.svg";